// extracted by mini-css-extract-plugin
export var editInput = "_gw-0";
export var editInputCompact = "_gw-2";
export var editInputLarge = "_gw-1";
export var editInputSmall = "_gw-3";